import { KText } from '@/ui-library/components';
import { Avatar, Divider, Flex, Icon } from '@chakra-ui/react';
import { Star06 } from '@kula-ai/icons/dual-tone/Star06';
import { useField } from 'formik';

export const SchInterviewerFieldAutoRecommend = ({
  recommendedData,
  setValue,
  setSelectOption,
}) => {
  const { isLoading, recommendedUser, isEmptyUsersFromTemplate, hide } =
    recommendedData || {};

  const [, { value }] = useField('kind');

  if (hide || isLoading) return null;

  if (isEmptyUsersFromTemplate || !recommendedUser?.id) {
    return null;
  }

  return (
    <>
      <Flex
        flexDir="column"
        w="100%"
        bgColor="secondary-50"
        borderRadius="6px"
        p="12px"
        gap="6px"
      >
        <Flex gap="6px">
          <Icon w="20px" h="20px" as={Star06} color="primary-500" />
          <KText variant="heading_4" color="primary-500">
            Recommended
          </KText>
        </Flex>
        <KText variant="heading_4" color="secondary-900" mb="10px">
          Based on interview load and availability
        </KText>
        <KText variant="small_text" textTransform="uppercase">
          click to select this interviewer
        </KText>
        <Flex
          bgColor="base-white"
          w="fit-content"
          border="1px solid"
          borderColor="border-color"
          gap="6px"
          p="6px 12px"
          alignItems="center"
          borderRadius="6px"
          cursor="pointer"
          onClick={() => {
            if (value === 'one_on_one') {
              setValue?.(recommendedUser?.id);
            } else {
              setValue?.([recommendedUser?.id]);
            }
            setSelectOption?.((prev) => {
              return [
                ...prev,
                {
                  ...recommendedUser,
                  value: recommendedUser?.id,
                  label: recommendedUser?.name,
                },
              ];
            });
          }}
        >
          <Avatar
            size="xs"
            borderRadius="3px"
            src={recommendedUser?.avatar}
            name={recommendedUser?.name}
          />
          <KText variant="heading_4">{recommendedUser?.name}</KText>
        </Flex>
      </Flex>
      <Flex align="center" my="6px">
        <Divider flex="1" borderColor="border-color" />
        <KText variant="heading_4" m="0 10px">
          OR
        </KText>
        <Divider flex="1" borderColor="border-color" />
      </Flex>
    </>
  );
};
